import { all, call, put, takeLatest, fork } from 'redux-saga/effects';
import { Creators as RdmsActions, Types as RdmsTypes } from 'store/ducks/Rdm';
import api from '../../util/Api';
import * as Sentry from '@sentry/react';

function* getRdms({ payload }) {
  try {
    const { status, data } = yield call(api.get, '/rdms', {
      params: payload,
    });
    if (status === 200) {
      yield put(RdmsActions.getRdmsSuccess(data));
    } else {
      Sentry.captureMessage('getRdms failed: status not 200', {
        level: 'error',
        extra: { payload, status, data },
      });
      yield put(RdmsActions.getRdmsError());
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(RdmsActions.getRdmsError());
  }
}

function* getRecsWatcher() {
  yield takeLatest(RdmsTypes.GET_RDMS, getRdms);
}

export default function* rootSaga() {
  yield all([fork(getRecsWatcher)]);
}
